import React from "react";
import "./Button.css";

export default function Button({ 
  children, 
  onClick = () => {}, 
  variant = "primary", // primary, secondary
  type = "button",
  disabled = false,
  fullWidth = false,
  className = "",
  ...props 
}) {
  const buttonClasses = [
    variant === "primary" ? "button-66" : "button-67",
    fullWidth ? "button-fullwidth" : "",
    disabled ? "button-disabled" : "",
    className
  ].filter(Boolean).join(" ");

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}